/**
 * Returns a promise that resolves after `document.readyState` changes to
 * `'complete'`.
 * @return {Promise<void>}
 */
function afterStateComplete() {
    return new Promise((resolve) => {
        // If the state is already complete, resolve inmediatlly and do nothing else
        if (document.readyState === 'complete') {
            return resolve();
        }
        /**
         * Listens 'readystatechange' and once the document.readyState is 'complete'
         * it resolves the parent promise and unregisters as a listener.
         */
        const listener = () => {
            if (document.readyState === 'complete') {
                document.removeEventListener('readystatechange', listener, false);
                resolve();
            }
        };
        document.addEventListener('readystatechange', listener, false);
    });
}

/**
 * Returns a promise that resolves after the undelying browser view is ready to work.
 * @return {Promise<void>}
 */
export default function bootstrapBrowser() {
    return Promise.all([
        afterStateComplete(),
    ]).then(() => {});
}



// WEBPACK FOOTER //
// ./src/shared/engine-dynamic/engines/browser.js